module.exports = __webpack_public_path__ + "static/p04_burroOrejaIzq-e52b1fabe0ccf064eb34174700597735.png";